import React from "react";
import Modal from "../../components/Modal";
import { Shift } from "../../util/types";

interface AssignedAgentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  shift: Shift | null;
}

const AssignedAgentsModal: React.FC<AssignedAgentsModalProps> = ({
  isOpen,
  onClose,
  shift,
}) => {
  if (!shift) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={`Agents in ${shift.shiftName}`}
    >
      <div className="max-h-96 overflow-y-auto">
        {shift.assignedAgents.length > 0 ? (
          <ul className="space-y-2">
            {shift.assignedAgents.map((agent) => (
              <li
                key={agent.id}
                className="flex items-center justify-between p-2 bg-gray-50  dark:bg-gray-700 rounded-lg"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="font-semibold dark:text-white text-gray-800 text-sm">
                      {agent.agentName}
                    </p>
                    <span className="text-xs dark:bg-gray-800 bg-gray-200 px-1.5 py-0.5 rounded">
                      {agent.gender}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">{agent.email}</p>
                </div>
                <span className="px-1.5 py-0.5 inline-flex text-xs leading-4 font-semibold rounded-full bg-green-100 text-green-800">
                  Eff: {Math.round(agent.efficiency)}%
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-center text-gray-500 py-6 text-base">
            No agents are assigned to this shift.
          </p>
        )}
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={onClose}
          className="bg-indigo-600 text-white font-semibold px-3 py-1.5 text-sm rounded-lg shadow-md hover:bg-indigo-700 transition-colors duration-200"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default AssignedAgentsModal;
